import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC4zKFsJ4L2yLrhfzhWbdA_Dy-79wMABX0",
  authDomain: "greek-philosophy-rag.firebaseapp.com",
  projectId: "greek-philosophy-rag",
  storageBucket: "greek-philosophy-rag.firebasestorage.app",
  messagingSenderId: "869507078735",
  appId: "1:869507078735:web:266ef88ff4246b6b86a83a"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

export function signInWithGoogle() {
  return signInWithPopup(auth, googleProvider);
}

export function signOutUser() {
  return signOut(auth);
}